import { render, staticRenderFns } from "./QuotationGrid.vue?vue&type=template&id=1fd2e0bd&scoped=true&"
import script from "./QuotationGrid.vue?vue&type=script&lang=js&"
export * from "./QuotationGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd2e0bd",
  null
  
)

export default component.exports